import { TranslateService } from "@ngx-translate/core";
import { find } from "lodash";
import * as moment from 'moment';
import { environment } from "../../../environments/environment";
import { IbanFormat } from "../../common/pipes/iban-format.pipe";
import { OrderLineItemTypeEnum } from "../../shared/enums/order-lineitem-type.enum";
import { CommonService } from "../../shared/services/common.service";
import { DeliveryPreference, PurchaseFlow } from "../common/enumerations";
import { StoreMetaDataConstants } from "../constants/store-metadata.constants";
import { MemberTypeEnum } from "../enums/member-type.enum";
import { AddressType, OrderStatus, PaymentMethodTypes } from "../enums/order-source-type";
import { PaymentCardTypes } from "../enums/payment-card-types.enum";
import { TaxType } from "../interface/tax-type.interface";
import { AppConfigService } from "../services/app-config.service";
import { CheckoutConfigService } from "../services/checkout-config.service";
import { CustomerService } from "../services/customer.service";
import { OrderConfigService } from "../services/order-config.service";
import { OrderService } from "../services/order.service";
import { PaymentMethodTypeConstants } from "../constants/payment-method-types.constants";
var PrintLayoutComponent = /** @class */ (function () {
    function PrintLayoutComponent(_appConfigService, _checkoutConfigService, _commonService, _orderConfig, _orderService, _translatePipe, _ibanFormatPipe, _customerservice) {
        this._appConfigService = _appConfigService;
        this._checkoutConfigService = _checkoutConfigService;
        this._commonService = _commonService;
        this._orderConfig = _orderConfig;
        this._orderService = _orderService;
        this._translatePipe = _translatePipe;
        this._ibanFormatPipe = _ibanFormatPipe;
        this._customerservice = _customerservice;
        this.memberLevel = '';
        this.latitude = 0;
        this.longitude = 0;
        this.errormessage = false;
        this.showDetail = false;
        this.showLineItem = false;
        this.empty = '';
        this.vatBreakdownStores = ['GBR', 'IRL', 'ILN'];
        this.taxType = TaxType;
        this.hasOrderLevelDiscount = false;
        this.hasBondedProduct = false;
        this.hasNonBondedProduct = false;
        this.paymentMethodTypeConstants = PaymentMethodTypeConstants;
        this.paymentType = PaymentMethodTypes;
    }
    PrintLayoutComponent.prototype.ngOnInit = function () {
        this.getMemberDetailById();
        this.getCountryConfig();
        this.getOrderDetails(this.orderDetails);
        if (this.distributorInfo && this.distributorInfo.memberTypeId
            && (this.distributorInfo.memberTypeId === MemberTypeEnum.DISTRIBUTOR)) {
            this.isDistributor = true;
        }
        if (this.distributorInfo && this.distributorInfo.memberTypeId && (this.distributorInfo.memberTypeId === MemberTypeEnum.FPC)) {
            this.isPrefferedCustomer = true;
        }
        //    this.vatNumber = this.store.vatNumber; 
        this.getStoreMetaData();
        this.getStoresInfo();
        window.scrollTo(0, 0);
    };
    /**
     * will get Country Based Configuration Values
     * @returns void
     * @memberof OrderDetailsComponent
     */
    PrintLayoutComponent.prototype.getCountryConfig = function () {
        if (this.orderDetails) {
            this.appCountryConfig = this._appConfigService.getSettings(this.orderDetails.countryCode, this.distributorInfo);
        }
    };
    /**
     * getOrderDetails Method used to get the order details
     * @param  {string} webOrderId
     * @returns void
     */
    PrintLayoutComponent.prototype.getOrderDetails = function (orderdetails) {
        if (orderdetails) {
            if (!orderdetails.shipToName && orderdetails.firstName && orderdetails.lastName) {
                orderdetails.shipToName = orderdetails.firstName + ' ' + (orderdetails.middleName && orderdetails.displayMiddleName
                    ? orderdetails.middleName + ' ' : '') + orderdetails.lastName;
            }
            if (orderdetails.isDM) {
                this.isDmUser = orderdetails.isDM;
                this.totalDiscountAmount = orderdetails.totalDiscountAmount &&
                    orderdetails.totalDiscountAmount > 0 ? orderdetails.totalDiscountAmount : null;
            }
            var countrycode = orderdetails.countryCode;
            if (environment.removeCommaOnInvoice) {
                this.removeCommaOnInvoive = environment.removeCommaOnInvoice.split(',').includes(countrycode);
            }
            this.myAccountConfig = this._checkoutConfigService.getSettings(countrycode, null);
            this.orderDetailsConfig = this._orderConfig.getSettings(countrycode, this.distributorInfo);
            this.vatBreakdownCountry = this.isVatBreakdownCountry(countrycode);
            this.orderDetails = orderdetails;
            this.displaySystemOrderNumber = this.myAccountConfig && this.myAccountConfig.displaySystemOrderNumber && this.orderDetails && this.orderDetails.source === 'POS' ? true : false;
            this.isRetailOrder = this.orderDetails.orderTypeId === PurchaseFlow.Retail;
            this.isServiceOrder = this.orderDetails.orderTypeId === PurchaseFlow.SERVICE;
            if (this.orderDetails && this.orderDetails.orderTypeId
                && this.orderDetails.orderTypeId === PurchaseFlow.Enrollment
                || this.orderDetails.orderTypeId === PurchaseFlow.Personal_Order) {
                this.enrolmentOrPersonalOrder = true;
            }
            this.getTranslatedProducts(countrycode);
            this.prepareOrderDetailsData(this.orderDetails);
            this.getOrderPaymentInfo(this.orderDetails.billingInfo);
            this.emptyCheck();
        }
    };
    /**
     * @description display order vat tax based on order type id and country taxinclusive
     * @memberof OrderDetailsComponent
     */
    PrintLayoutComponent.prototype.displayOrderVatTax = function () {
        var _this = this;
        if (this.appCountryConfig.enableVATCalculation && this.orderDetailsConfig.displayVat && this.orderDetails) {
            if (this.orderDetails.orderTypeId === PurchaseFlow.Enrollment && this.orderDetails.initialOrder
                && this.orderDetails.vatRegistered) {
                this.orderDetailsConfig.displayVat = true;
            }
            else if (this.shippingAddressInfo && this.shippingAddressInfo.countryId && this.participatingCountries
                && this.participatingCountries.length && this.orderDetails.vatRegistered) {
                var country = this.participatingCountries
                    .find(function (x) { return x.countryId === _this.shippingAddressInfo.countryId; });
                this.orderDetailsConfig.displayVat = this.getCountryTaxInclusiveInfo(country);
            }
            else {
                this.orderDetailsConfig.displayVat = false;
            }
        }
        else if (this.orderDetailsConfig.displayVat && !this.orderDetailsConfig.enableVATCalculation) {
            this.orderDetailsConfig.displayVat = true;
        }
        else {
            this.orderDetailsConfig.displayVat = false;
        }
        if (this.vatBreakdownCountry) {
            this.orderDetailsConfig.displayVat = true;
        }
    };
    /**
    * @description to get taxinclusive info
    * @memberof OrderDetailsComponent
    */
    PrintLayoutComponent.prototype.getCountryTaxInclusiveInfo = function (country) {
        var countryTaxInclusive = false;
        if (country && country.countryMetadata &&
            country.countryMetadata.length > 0 &&
            country.countryMetadata[0].metadata) {
            countryTaxInclusive = (country.countryMetadata[0].metadata[0].value === 'TRUE') ? true : false;
        }
        return countryTaxInclusive;
    };
    /**
     *
     * @param storeId
     */
    PrintLayoutComponent.prototype.getStoreMetaData = function () {
        var _this = this;
        if (this.storeMetaInfo && this.storeMetaInfo.length > 0) {
            // const metaData = this.storeMetaInfo.find(x => (x.attribute &&
            //     x.attribute.toLowerCase() === StoreMetaDataConstants.CORPORATE_VAT_ID.toLowerCase()));
            // if (metaData && metaData.metaDataValue) {
            //     this.corporateVatId = metaData.metaDataValue;
            // }
            this.storeMetaInfo.forEach(function (metaData) {
                if (metaData && metaData.metaDataValue && metaData.attribute) {
                    if (metaData.attribute.toLowerCase() === StoreMetaDataConstants.CORPORATE_VAT_ID.toLowerCase()) {
                        _this.corporateVatId = metaData.metaDataValue;
                    }
                    if (metaData.attribute.toLowerCase() === StoreMetaDataConstants.ORGANIZATION_NUMBER.toLowerCase()) {
                        _this.organizationNumber = metaData.metaDataValue;
                    }
                    if (metaData.attribute.toLowerCase() === StoreMetaDataConstants.TAX_CERTIFICATE_NOTE.toLowerCase()) {
                        _this.taxCertificateNote = metaData.metaDataValue;
                    }
                    if (metaData.attribute.toLowerCase() === StoreMetaDataConstants.PLACE_OF_INCORPORATION.toLowerCase()) {
                        _this.placeOfIncorporation = metaData.metaDataValue;
                    }
                    if (metaData.attribute.toLowerCase() === StoreMetaDataConstants.ENABLE_WATERMARK_IN_INVOICE.toLowerCase()) {
                        _this.showWatermarkInInvoice = (metaData.metaDataValue.toLowerCase() == 'true');
                        if (_this.showWatermarkInInvoice)
                            _this.watermarkMessage = _this.populateWatermark();
                    }
                    if (metaData.attribute.toLowerCase() === StoreMetaDataConstants.CREDITOR_ID.toLowerCase()) {
                        _this.creditorID = metaData.metaDataValue;
                    }
                }
            });
        }
    };
    PrintLayoutComponent.prototype.getStoresInfo = function () {
        if (this.orderStoreInfo) {
            this.vatNumber = this.orderStoreInfo.vatNumber;
            this.enableVatinInvoice = this.orderStoreInfo.enableVatInInvoice;
            this.orderStoreInfo.ccNumberDecimals = 3;
            this.orderStoreInfo.ccNumberFormat = 'CR';
            this.orderStoreInfo.ccSymbol = 'CC';
            this.timezoneOffset = this.orderStoreInfo.timeZoneOffset ? (this.orderStoreInfo.timeZoneOffset * 60) : 0;
        }
    };
    /**
     * prepareOrderDetailsData Method used to set the order details data
     * @param  {any} orderDetails
     * @returns void
     */
    PrintLayoutComponent.prototype.prepareOrderDetailsData = function (orderDetails) {
        var _this = this;
        var symbol;
        this.distributorName = this.distributorInfo.firstName + ' ' + this.distributorInfo.lastName;
        this.memberLevel = this.distributorInfo.memberTitle;
        var enableWHLSAL00ForAsstSupervisor = this._commonService.isWHLSAL00enabledForAsstSupervisor(this.orderDetails.countryCode);
        this.priceTierName = this._commonService.getDiscountPriceLevel(this.orderDetails.priceTierId, this.orderDetails.memberLevelDiscount, this.orderDetails.memberTypeId, enableWHLSAL00ForAsstSupervisor);
        this.fboId = this.orderDetails.distrubutorId;
        this.orderNumber = this.orderDetailsConfig.displayErpNumber ? this.orderDetails.erpNumber : this.orderDetails.orderNumber;
        this.webOrderId = this.orderDetails.webOrderId;
        this.globalOrderNumber = this.orderDetails && this.orderDetails.globalOrderNumber ? this.orderDetails.globalOrderNumber : null;
        this.orderDate = moment.utc(this.orderDetails.createdDate).format('DD-MMM-YYYY');
        this.orderDetails.orderLineItems.sort(function (a, b) {
            return a.orderLineNumber - b.orderLineNumber;
        });
        var orderLineItems = [];
        //this.lineItems = this.orderDetails.orderLineItems;
        if (this.orderDetailsConfig.displayVatTaxLineItem || this.vatBreakdownCountry) {
            this.orderDetails.orderLineItems.forEach(function (lineItem) {
                if (lineItem.lineItemTypeId != OrderLineItemTypeEnum.CHILD_PRODUCT) {
                    orderLineItems.push(lineItem);
                }
            });
            this.lineItems = orderLineItems;
        }
        else {
            this.lineItems = this.orderDetails.orderLineItems;
        }
        this.hasOrderLevelDiscount = this.orderDetails.orderLevelDiscount ? true : false;
        if (this.orderDetailsConfig && this.orderDetailsConfig.isDEUCountry && this.orderDetails && this.orderDetails.taxMetaData && this.orderDetails.taxMetaData.orderTaxCharges) {
            var items_1 = this.orderDetails.taxMetaData.orderTaxCharges;
            items_1.forEach(function (element, index) {
                if (element.lineNo === 0) {
                    if (_this.hasOrderLevelDiscount) {
                        items_1[index].taxChargeBased = element.taxChargeBased - element.taxAmount;
                    }
                    _this.shippingTaxRate = element.taxRate;
                }
            });
        }
        var hasNonBondedProduct = this.lineItems.find(function (x) { return !x.bondedProduct; });
        if (this.hasOrderLevelDiscount) {
            this.hasBondedProduct = true;
            this.orderDetails.taxMetaData.orderTaxCharges = this.orderDetails.taxMetaData.orderTaxCharges.filter(function (item) { return item.taxRate > 0 || _this.orderDetailsConfig.displayTotalColumnOnTaxChargeTypeZero; });
        }
        if (hasNonBondedProduct) {
            this.hasBondedProduct = false;
            this.hasNonBondedProduct = true;
        }
        this.donationItemExist = this.orderDetails.orderLineItems.find(function (x) { return x.lineItemTypeId == OrderLineItemTypeEnum.DONATION_PRODUCT; });
        this.itemSubTotal = this.orderDetails.orderSubTotal;
        this.totalQty = this.getTotalQuantity(this.lineItems);
        this.shipping = this.orderDetailsConfig.calculateShippingWithTax && this.orderDetails.shippingCost && this.orderDetails.shippingTax
            && (!this.orderDetails.vatRegistered || this.orderDetails.memberTypeId !== MemberTypeEnum.DISTRIBUTOR) ?
            this.orderDetails.shippingCost + this.orderDetails.shippingTax : this.orderDetails.shippingCost;
        this.orderDetails.shippingCost = this.orderDetailsConfig.calculateShippingWithTax && this.orderDetails.shippingCost
            && this.orderDetails.shippingTax && (!this.orderDetails.vatRegistered ||
            this.orderDetails.memberTypeId !== MemberTypeEnum.DISTRIBUTOR)
            ? this.orderDetails.shippingCost + this.orderDetails.shippingTax : this.orderDetails.shippingCost;
        this.orderDetails.shippingCost = this.orderDetails.shippingCost ? this.orderDetails.shippingCost : 0;
        this.tax = this.orderDetails && this.orderDetails.retailDeliveryFee ? (this.orderDetails.orderTax - this.orderDetails.retailDeliveryFee) : this.orderDetails.orderTax;
        this.total = (this.orderDetails.orderTotal === '' ? '0.0' : this.orderDetails.orderTotal);
        this.totalcc = this.orderDetails.orderTotalCC;
        this.emailId = this.orderDetails.email;
        //this.handling = this.orderDetails.handling;
        this.currencyType = this.orderDetails.currencyType;
        symbol = find(this.currencySymbols, { currencyCode: this.currencyType });
        this.currencySymbol = symbol ? symbol.currencySymbol : '$';
        if (this.orderDetails.orderShippings && this.orderDetails.orderShippings.length > 0) {
            if (this.orderDetails.orderShippings[0].deliveryPreferenceId === DeliveryPreference.PICKUP) {
                this.isPickUp = true;
            }
            else {
                this.getShipMethodInfo(this.orderDetails);
                if (this.orderDetailsConfig && !this.orderDetailsConfig.isDisplayShipping) {
                    this.orderDetailsConfig.handlingDisplay = true;
                }
            }
        }
        if (this.orderDetails.addresses && this.orderDetails.addresses.length > 0) {
            this.getMemberAddressByMemberId(this.orderDetails.addresses);
            this.getParticipatingCountries(this.orderDetails.countryCode);
            this.displayOrderVatTax();
            this.calculateTotals(this.lineItems, this.orderDetails.shippingCost, this.orderDetails.importFeeValue);
        }
        else {
            this.displayOrderVatTax();
            this.calculateTotals(this.lineItems, this.orderDetails.shippingCost, this.orderDetails.importFeeValue);
        }
        if (this.orderDetails && this.orderDetails.taxMetaData
            && this.orderDetails.taxMetaData.orderTaxCharges && this.orderDetails.taxMetaData.orderTaxCharges.length) {
            var gst = this.orderDetails.taxMetaData.orderTaxCharges.find(function (tax) { return tax.taxChargeType === TaxType.GST_TAX; });
            var pst = this.orderDetails.taxMetaData.orderTaxCharges.find(function (tax) { return tax.taxChargeType === TaxType.PST_TAX; });
            this.gstTax = gst ? gst.taxAmount : 0;
            this.pstTax = pst ? pst.taxAmount : 0;
        }
        // PS2020-489 --> USA Tax issue
        if (this.orderDetails && (!this.orderDetails.orderTax || this.orderDetails.orderTax <= 0)
            && this.orderDetails.countryCode === 'USA' && this.orderDetails.taxMetaData
            && this.orderDetails.taxMetaData.orderTaxCharges
            && this.orderDetails.taxMetaData.orderTaxCharges.length > 0) {
            var slsTax = this.orderDetails.taxMetaData
                .orderTaxCharges.find(function (tax) { return tax.taxChargeType === TaxType.SLS_TAX; });
            this.tax = slsTax ? slsTax.taxAmount : 0;
        }
        this.phoneNumberFormat = this._commonService.getPhoneNumberFormatByCountryCode(this.orderDetails.countryCode);
    };
    /**
    * get total quantity from orderline items
    * @returns number
    */
    PrintLayoutComponent.prototype.getTotalQuantity = function (orderLineItems) {
        var totalQty = 0;
        if (orderLineItems && orderLineItems.length) {
            orderLineItems.forEach(function (item) {
                if (!item.depositFeeProduct) {
                    totalQty = totalQty + item.quantity;
                }
            });
        }
        return totalQty;
    };
    /**
    * get totals from orderline items
    * @returns number
    */
    PrintLayoutComponent.prototype.calculateTotals = function (orderLineItems, shippingCost, importFeeValue) {
        var totalUnitPrice = 0;
        var totalTaxableAmount = 0;
        var totalExtendedPrice = 0;
        var totalRetailPrice = 0;
        var totalBwpExtendedPrice = 0;
        if (orderLineItems && orderLineItems.length) {
            orderLineItems.forEach(function (item) {
                totalUnitPrice = totalUnitPrice + item.unitPaidPrice;
                totalRetailPrice = totalRetailPrice + (item.unitRetailPrice * item.quantity);
                totalTaxableAmount = totalTaxableAmount + item.totalRetailPrice;
                totalExtendedPrice = totalExtendedPrice + item.totalAmount;
                if (item.bondedProduct)
                    totalBwpExtendedPrice = totalBwpExtendedPrice + item.totalAmount;
            });
        }
        var wholesaleQualified;
        var optin;
        if (this.orderDetails) {
            wholesaleQualified = this.orderDetails.wholesaleQualified;
            optin = this.orderDetails.optin;
        }
        // const discountPerc = this._commonService.getDiscountPerc(memberTitleId, wholesaleQualified, optin);
        var discountPerc = this.orderDetails.memberLevelDiscount;
        this.totalSavings = discountPerc ? (totalRetailPrice * discountPerc) / 100 : 0;
        this.totalUnitPrice = totalUnitPrice + (shippingCost ? shippingCost : 0) + (importFeeValue ? importFeeValue : 0);
        this.totalTaxableAmount = totalTaxableAmount + (shippingCost ? shippingCost : 0) + (importFeeValue ? importFeeValue : 0);
        this.totalExtendedPrice = totalExtendedPrice + (shippingCost ? shippingCost : 0) + (importFeeValue ? importFeeValue : 0);
        if (totalBwpExtendedPrice) {
            this.totalDiscountAmount = this.orderDetails.orderLevelDiscount;
            this.bwpBaseChargeAmount = totalBwpExtendedPrice - this.totalDiscountAmount;
        }
    };
    PrintLayoutComponent.prototype.emptyCheck = function () {
        if (this.shippingAddressInfo && this.shippingAddressInfo.shipToName === this.empty
            && this.shippingAddressInfo.phone === this.empty && this.shippingAddressInfo.email === this.empty
            && this.shippingAddressInfo.addressLine1 === this.empty && this.shippingAddressInfo.addressLine1 === this.empty
            && this.shippingAddressInfo.city === this.empty
            && this.shippingCountry === this.empty && this.shippingAddressInfo.stateCode === this.empty) {
            this.showDetail = false;
        }
        else {
            this.showDetail = true;
        }
        if (this.paymentCardType === this.empty && this.expDate === this.empty && this.paymentCardNo === this.empty) {
            this.showPayment = true;
        }
        else {
            this.showPayment = false;
        }
        if (this.lineItems && this.lineItems.length === 0) {
            this.showLineItem = true;
        }
        else {
            this.showLineItem = false;
        }
    };
    /**
     * @description  prepare MemberAddress
     * @author Akhil
     * @date 2020-11-27
     * @param {*} addresses
     * @memberof PrintLayoutComponent
     */
    PrintLayoutComponent.prototype.getMemberAddressByMemberId = function (addresses) {
        var _this = this;
        this.shippingAddressInfo = null;
        this.memberAddressDetails = [];
        addresses.forEach(function (address) {
            var name = '';
            if (address && address.firstName && address.lastName) {
                var middleName = _this.orderStoreInfo && _this.orderStoreInfo.displayMiddleName && address.middleName ? address.middleName : '';
                name = address.firstName + ' ' + (middleName ? middleName + ' ' : '') + address.lastName;
            }
            else if (_this.shippingAddressInfo && address.shipToName || address.name) {
                name = address.shipToName || address.name;
            }
            _this.memberAddressDetails.push({
                id: address.id,
                shipToName: name || address.name || '',
                addressLine1: address.addressLine1,
                addressLine2: address.addressLine2,
                addressLine3: address.addressLine3,
                addressLine4: address.addressLine4,
                addressType: address.addressType,
                city: address.city,
                stateId: address.stateId,
                countryId: address.countryId,
                state: address.state,
                stateCode: address.stateCode,
                country: address.country,
                countryCode: address.countryCode,
                postalCode: address.postalCode,
                addressVerified: address.addressVerified,
                phone: address.phone,
                email: address.email,
                firstName: address.firstName,
                lastName: address.lastName,
                middleName: address.middleName,
                displayMiddleName: _this.orderStoreInfo ? _this.orderStoreInfo.displayMiddleName : false
            });
        });
        if (this.memberAddressDetails.length > 0) {
            var shippingInfo = this.memberAddressDetails.find(function (address) {
                return (address.addressType === AddressType.SHIPPING) || (address.addressType === AddressType.PICKUP) || (address.addressType === AddressType.PICKUP_PERSON) || (address.addressType === AddressType.DROPSHIP);
            });
            this.shippingAddressInfo = shippingInfo;
            this.shippingCountry = this.shippingAddressInfo.country;
        }
    };
    /**
     * @description  to prepare payment Detaiils
     * @author Akhil
     * @date 2020-11-27
     * @param {*} paymentResonse
     * @memberof PrintLayoutComponent
     */
    PrintLayoutComponent.prototype.getOrderPaymentInfo = function (paymentResonse) {
        if (paymentResonse) {
            this.paymentInfo = true;
            this.paymentDetails = paymentResonse;
            if (this.appCountryConfig && this.appCountryConfig.displayStatementForWavePayment) {
                if (this.paymentDetails.paymentMethod === PaymentMethodTypes.Money_order)
                    this.paymentDetails.paymentMethod = PaymentMethodTypeConstants.Wave;
                else if (this.paymentDetails.paymentMethod === PaymentMethodTypeConstants.Orange_Money)
                    this.paymentDetails.paymentMethod = PaymentMethodTypeConstants.Orange_Money;
            }
            this.paymentMethod = this.paymentDetails.paymentMethod ? this.paymentDetails.paymentMethod : 'NA';
            this.isSingleOrDirect = this.paymentMethod && (this.paymentMethod === PaymentMethodTypes['Direct_Debit'] || this.paymentMethod === PaymentMethodTypes['Single_Debit']);
            if (this.isSingleOrDirect)
                this.obfuscatedIban = this._ibanFormatPipe.transform(this.paymentDetails.accountNumber);
            var paymentLabel = this.paymentMethod ?
                PaymentMethodTypes[this.paymentMethod] ? this._commonService.getPaymentTypeLabel(this.paymentMethod) : this.paymentMethod : 'NA';
            this.isIntegratedTerminalAdyenPymt = (paymentLabel == PaymentMethodTypeConstants.Integrated_Terminal_Adyen ? true : false);
            this.paymentCardType = this.paymentDetails.cardType ? this.paymentDetails.cardType : 'NA';
            var cardLabel = this.paymentCardType ?
                PaymentCardTypes[this.paymentCardType] ? PaymentCardTypes[this.paymentCardType] : this.paymentCardType : 'NA';
            this.paymentCardNo = this.paymentDetails.maskedCard ? this.paymentDetails.maskedCard : 'NA';
            this.expDate = this.paymentDetails.expiryMonth ? (this.paymentDetails.expiryMonth +
                '/' + this.paymentDetails.expiryYear.substring(2, 4)) : 'NA';
            this.moComponentSettings = this.preparePaymentLables(paymentLabel, cardLabel);
        }
    };
    PrintLayoutComponent.prototype.getShipMethodInfo = function (orderDetails) {
        if (this.orderDetails && this.orderDetails.orderShippings.length > 0
            && this.orderDetails.orderShippings[0].shipMethodId && this.orderDetails.storeId) {
            this.shipFrom = this.orderDetails.orderShippings[0].distributionCenter;
            this.shippingMethod = this.orderDetails.shippingInfo.shippingMethod;
            this.shippingImage = this.shippingMethod.replace(/\s/g, '');
        }
    };
    /**
     * setDefaultShippingPic Method used to display default text for Shipping method
     * @returns void
     */
    PrintLayoutComponent.prototype.setDefaultShippingPic = function () {
        this.shippingImageFlag = false;
    };
    /**
     *
     * @param items
     */
    PrintLayoutComponent.prototype.getItemVolumeSum = function (items) {
        if (this.appCountryConfig.roundoffTaxAmount) {
            return Math.round(items
                .map(function (x) { return x.taxAmount; })
                .reduce(function (a, b) { return a + b; }));
        }
        else {
            return items
                .map(function (x) { return x.taxAmount; })
                .reduce(function (a, b) { return a + b; });
        }
    };
    PrintLayoutComponent.prototype.getItemTaxChargeBasedSum = function (items) {
        return items
            .map(function (x) { return x.taxChargeBased; })
            .reduce(function (a, b) { return a + b; });
    };
    /**
     * orderInvoice Method used to implement print functionality
     * @returns void
     */
    PrintLayoutComponent.prototype.orderInvoice = function () {
        window.print();
    };
    /**
     * get Participating countries
     * @param countryCode
     */
    PrintLayoutComponent.prototype.getParticipatingCountries = function (countryCode) {
        if (this.countries) {
            this.participatingCountries = this.countries;
            if (this.appCountryConfig.enableVATCalculation) {
                this.orderDetailsConfig.displayVat = this.distributorInfo.memberTypeId === MemberTypeEnum.DISTRIBUTOR ? true : false;
            }
            if (this.vatBreakdownCountry) {
                this.orderDetailsConfig.displayVat = true;
            }
            this.displayOrderVatTax();
        }
    };
    /**
     * @description prepare Payment Types ;
     * @author Akhil
     * @date 2020-11-27
     * @param {*} paymentLabel
     * @param {*} cardLabel
     * @returns {*}
     * @memberof PrintLayoutComponent
     */
    PrintLayoutComponent.prototype.preparePaymentLables = function (paymentLabel, cardLabel) {
        var paymentTypes = PaymentMethodTypes;
        var payementDetails = {
            paymentMethodTypes: paymentTypes,
            paymentMethodLabel: paymentLabel,
            cardTypeLabel: cardLabel
        };
        return payementDetails;
    };
    /**
     * @description getregistered Address
     * @author Akhil
     * @date 2020-11-30
     * @memberof PrintLayoutComponent
     */
    PrintLayoutComponent.prototype.getMemberDetailById = function () {
        var _this = this;
        this._customerservice.getMemberBasicInfoById(this.orderDetails.memberId).subscribe(function (memberResponse) {
            if (memberResponse) {
                _this.memberAddressInfo = memberResponse;
                if (_this.memberAddressInfo) {
                    _this.memberBusinessEntities = _this.memberAddressInfo.businessEntities ? _this.memberAddressInfo.businessEntities : null;
                    if (_this.memberAddressInfo.businessEntityHistories) {
                        (_a = _this.memberBusinessEntities).push.apply(_a, _this.memberAddressInfo.businessEntityHistories);
                    }
                    _this.registerAddress = _this.memberAddressInfo.address;
                    _this.registerAddress.firstName = _this.registerAddress.firstName ? _this.registerAddress.firstName
                        : _this.memberAddressInfo.firstName ? _this.memberAddressInfo.firstName : null;
                    if (_this.orderStoreInfo && _this.orderStoreInfo.displayMiddleName) {
                        _this.registerAddress.middleName = _this.registerAddress.middleName ? _this.registerAddress.middleName
                            : _this.memberAddressInfo.middleName ? _this.memberAddressInfo.middleName : null;
                    }
                    _this.registerAddress.lastName = _this.registerAddress.lastName ? _this.registerAddress.lastName
                        : _this.memberAddressInfo.lastName ? _this.memberAddressInfo.lastName : null;
                    _this.registerAddress.phoneNumber = _this.registerAddress.phoneNumber ? _this.registerAddress.phoneNumber
                        : _this.memberAddressInfo.phone ? _this.memberAddressInfo.phone : null;
                    _this.registerAddress.email = _this.registerAddress.email ? _this.registerAddress.email
                        : _this.memberAddressInfo.email ? _this.memberAddressInfo.email : null;
                    _this.registerAddressphoneNumberFormat = _this._commonService.getPhoneNumberFormatByCountryCode(_this.registerAddress.countryCode);
                    _this.prepareBusinessEntity();
                }
            }
            var _a;
        });
    };
    PrintLayoutComponent.prototype.getFlpLogo = function () {
        return environment.uiTemplateBaseUrl + '/images/flpi-logo.jpg';
    };
    /**
     * @description To get translated product for order invoice
     * @date 2021-11-17
     * @memberof PrintLayoutComponent
     */
    PrintLayoutComponent.prototype.getTranslatedProducts = function (countryCode) {
        var _this = this;
        var purchaseFlowType = this._commonService.getPurchaseFlowType(this.orderDetails.memberTypeId, this.orderDetails.wholesaleQualified, this.appCountryConfig.fpc5PercentEnabled, false, this.distributorInfo.memberTitleId);
        var language = JSON.parse(localStorage.getItem('appadmin.language'));
        var productIds = [];
        productIds = this.orderDetails.orderLineItems.map(function (x) { return x.productId; });
        if (productIds && productIds.length > 0) {
            this._orderService.getProductsByIds(productIds, language, this.orderDetails.storeId, this.distributorInfo.memberTitleId, purchaseFlowType, countryCode, this.orderDetails.wholesaleQualified, this.orderDetails.optIn, this.orderStoreInfo.taxInclusive).subscribe(function (products) {
                if (products) {
                    _this.orderDetails.orderLineItems.forEach(function (lineItem) {
                        var filteredProduct = products.find(function (x) { return x.id === lineItem.productId; });
                        if (filteredProduct && filteredProduct.displayName) {
                            lineItem.productName = filteredProduct.displayName;
                        }
                    });
                }
            });
        }
        this.totalRetailPrice = this.orderDetails.orderLineItems.reduce(function (sum, y) {
            if (!(y.lineItemTypeId === OrderLineItemTypeEnum.CHILD_PRODUCT)) {
                return sum + (y.unitRetailPrice * y.quantity);
            }
            return sum;
        }, 0);
        this.totalDiscount = this.orderDetails.orderLineItems.reduce(function (sum, y) {
            if (!(y.lineItemTypeId === OrderLineItemTypeEnum.CHILD_PRODUCT)) {
                return sum + ((y.unitRetailPrice - y.unitPaidPrice) * y.quantity);
            }
            return sum;
        }, 0);
    };
    PrintLayoutComponent.prototype.isVatBreakdownCountry = function (isoCountryCode) {
        return this.vatBreakdownStores.find(function (country) { return country === isoCountryCode.toUpperCase(); }) ? true : false;
    };
    PrintLayoutComponent.prototype.populateWatermark = function () {
        var msg = "";
        if (this.orderDetails && this.orderDetails.orderStatusId) {
            if (this.orderDetails.orderStatusId == OrderStatus.Pending)
                return msg = this._translatePipe.get('order.Add Watermark to Invoice-Pending')['value'];
            if (this.orderDetails.orderStatusId == OrderStatus.Cancelled)
                return msg = this._translatePipe.get('order.Add Watermark to Invoice-Cancelled')['value'];
        }
        return msg;
    };
    PrintLayoutComponent.prototype.prepareBusinessEntity = function () {
        this.activeBusinessEntity = null;
        var businessEntityId = null;
        businessEntityId = this.orderDetails && this.orderDetails.businessEntityId ? this.orderDetails.businessEntityId : null;
        if (this.memberBusinessEntities && businessEntityId) {
            this.activeBusinessEntity = this.memberBusinessEntities.find(function (item) {
                return item && item.id === businessEntityId;
            });
        }
    };
    PrintLayoutComponent.prototype.prepareBusinessEntityByOrderDate = function () {
        var _this = this;
        this.activeBusinessEntity = null;
        var businessEntityId = null;
        var fromDateFormat = 'DD-MM-YYYY';
        var toDateFormat = 'YYYY-MM-DD';
        businessEntityId = this.orderDetails && this.orderDetails.businessEntityId ? this.orderDetails.businessEntityId : null;
        var orderedDate = moment(this.orderDetails.createdDate).utcOffset(this.timezoneOffset).format(toDateFormat);
        if (this.memberBusinessEntities && businessEntityId && orderedDate) {
            var country_1 = this.countries && this.countries.find(function (country) { return country.isocodeThree && country.isocodeThree.toLowerCase() === _this.orderDetails.countryCode.toLowerCase(); });
            this.activeBusinessEntity = this.memberBusinessEntities.find(function (item) {
                return item && item.id === businessEntityId
                    && country_1 && country_1.countryId === item.countryCodeId;
            });
            var isValid = false;
            if (this.activeBusinessEntity && this.activeBusinessEntity.startDate) {
                if (this.activeBusinessEntity.startDate) {
                    var start = this.activeBusinessEntity.startDate ? moment(this.activeBusinessEntity.startDate, fromDateFormat).format(toDateFormat) : null;
                    var end = this.activeBusinessEntity.endDate ? moment(this.activeBusinessEntity.endDate, fromDateFormat).format(toDateFormat) : null;
                    if (start) {
                        if (end) {
                            isValid = moment(orderedDate).isBetween(start, end, null, '[]');
                        }
                        else {
                            isValid = moment(orderedDate).isSameOrAfter(start);
                        }
                    }
                }
            }
            if (!isValid) {
                this.activeBusinessEntity = null;
            }
        }
    };
    return PrintLayoutComponent;
}());
export { PrintLayoutComponent };



// WEBPACK FOOTER //
// ./src/app/customerservice/components/print-layout.component.ts.pre-build-optimizer.js